import { baseQuery } from '../baseQuery';

export const getAbn = async (abn: string) => {
  const data = await baseQuery(`abnlookup?search_value=${abn}`);

  return data;
};
